import { Spacing } from "@p0security/ui";
import { AssessmentSettingsSection } from "components/Assessment/styles";

import { AssessmentSummary } from "../../JobSummary";

export const EnvironmentStatusPage: React.FC = () => (
  <Spacing mb={24}>
    <AssessmentSettingsSection>
      <AssessmentSummary showRun />
    </AssessmentSettingsSection>
  </Spacing>
);

export default EnvironmentStatusPage;
